import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { GameInfoLayerWrapper, PromotionLabelWrapper, LinkOverride, WatchFreeWrapper, NationalBroadcastWrapper } from './GameInfoLayer.style';
import { getBroadcastsConfigState } from 'bdata-sns-shared/store/selectors/broadcastsConfigSelector';
import getTranslation from 'bdata-sns-shared/utils/getTranslation';

const GameInfoLayer = ({
    freeGameList,
    isFreeGame,
    nationalBroadcaster
}) => {
    const { dictionary } = useSelector(getBroadcastsConfigState) || {};

    const content = useMemo(() => {
        if (freeGameList) {
            const { shortTextLabelKey, url } = freeGameList || {};
            const partnerText = getTranslation(dictionary, shortTextLabelKey, '');
            return <PromotionLabelWrapper>
                { url ? <LinkOverride url={url} target={'_blank'}>{partnerText}</LinkOverride> : partnerText}
            </PromotionLabelWrapper>;
        } else if (isFreeGame) {
            const freeGameLabel = getTranslation(dictionary, 'freegameoftheday_short', 'Watch Free');
            return <WatchFreeWrapper>{ freeGameLabel }</WatchFreeWrapper>;
        } else if (nationalBroadcaster) {
            return <NationalBroadcastWrapper>
                { nationalBroadcaster }
            </NationalBroadcastWrapper>;
        }
        return null;
    }, [freeGameList, isFreeGame, nationalBroadcaster]);

    return (
        <GameInfoLayerWrapper>
            { content }
        </GameInfoLayerWrapper>
    );
};

GameInfoLayer.propTypes = {
    freeGameList: PropTypes.array,
    isFreeGame: PropTypes.bool,
    nationalBroadcaster: PropTypes.string
};

export default GameInfoLayer;
